import { appEnv } from "@utils";

const dev_team_seat_id = "price_1JXBpUIRfDf1dOjWoPKGdZGj";
const staging_team_seat_id = "price_1JXZghJNxZlz6RtL5yHf1bb2";
const prod_team_seat_id = "price_1JXZksJNxZlz6RtLMlz0vIyM";

// Publishable API keys (start with pk) are meant solely to identify your account with Stripe,
// they aren’t secret. In other words, they can safely be published in places like your
// Stripe.js JavaScript code, or in an Android or iPhone app.
export const get_stripe_pk = () => {
  switch (appEnv) {
    case "prod":
      return "pk_live_51HDZBaJNxZlz6RtLl5wEuxgV8AXUqgw2bdTkCupdU4nwB31vvvyc5DQeC6JhJR3k125gmY8gdmAyjvTIHauXGmq500nryzkN4v";
    case "staging":
      return "pk_test_51HDZBaJNxZlz6RtLTx8EKbFuiZAU6fSq1ARR8zD8x6nb5aBekHEPEpBZcd4Ag7NFDcQl6YJ7BY7q3QhsGtF4wE1j001k3QWssL";
    default:
      // dev and localhost both use dev db, so ok to group together here
      return "pk_test_51JDYW5IRfDf1dOjWyCVWyvBc84hkWABRpi4iyBj1IgZRqqPVZ6BMQGON2qqOS3tq8MKC5Ez2nsGb5fEwCYcpSgrs00VnOgg5og";
  }
};

export const get_team_seat_id = () => {
  switch (appEnv) {
    case "prod":
      return prod_team_seat_id;
    case "staging":
      return staging_team_seat_id;
    default:
      // dev and localhost both use dev db, so ok to group together here
      return dev_team_seat_id;
  }
};
